import { ThemeProvider } from "@emotion/react";
import { CssBaseline, styled } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { FormManage } from "./form/form-manage";
import { FormOriginalManage } from "./form/formOriginal-manage";
import { Forms } from "./pages/form/forms";
import { Mortgages } from "./pages/mortgages/mortgages";
import { Quotes } from "./pages/quotes/quotes";
import { BrandEnum } from "./_common/enum/brand.enum";
import { resolveBrandFromUrl } from "./_const/brandOrigin.const";
import { getParentOrigin } from "./_helpers/parentOrigin.helper";
import { getThemeForBrand } from "./_styles/brand.theme.styles";


const useStyles = {
    appScreen: {
        display: "flex",
        backgroundColor: "#fff",
        height: "100%",
    } as React.CSSProperties,
};

const Main = styled("main")(({ theme }) => ({
    flexGrow: 1,
    width: "100%",
    maxWidth: "100%",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    boxSizing: "border-box",
}));

function BrandedApp({ brand }: { brand: BrandEnum }) {
    const theme = useMemo(() => getThemeForBrand(brand), [brand]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <div style={{ ...useStyles.appScreen, position: "relative" }} id="app-screen">
                <div id="lq-turnstile" />
                <Main>
                    <BrowserRouter>

                        <Routes>
                            <Route path="/" element={<Navigate to="/Forms" replace />} />
                            <Route path="/Quotes" element={<Quotes brand={brand} />} />
                            <Route path="/Quotes/:productName/:formId/" element={<Quotes brand={brand} />} />
                            <Route path="/Mortgages/:formId" element={<Mortgages brand={brand} />} />
                            <Route path="/Forms" element={<Forms brand={brand} />} />
                            <Route path="/Forms/:formId" element={<FormManage brand={brand} />} />
                            <Route path="/Forms/:formId/:clientId" element={<FormManage brand={brand} />} />
                            <Route path="/FormOriginal/:formId" element={<FormOriginalManage brand={brand} />} />
                            <Route path="/FormOriginal/:formId/:quoteId" element={<FormOriginalManage brand={brand} />} />
                            <Route path="/FormOriginal" element={<FormOriginalManage brand={brand} />} />

                        </Routes>
                    </BrowserRouter>
                </Main>
            </div>
        </ThemeProvider>
    );
}

function App() {
    const [activeBrand, setActiveBrand] = useState<BrandEnum | null>(BrandEnum.Low); 

    //const [activeBrand, setActiveBrand] = useState<BrandEnum | null>(null);


    useEffect(() => {
        const detected = getParentOrigin();
        if (detected) {
            const matched = resolveBrandFromUrl(detected);
            if (matched) {
                setActiveBrand(matched);
            }
        }
    }, []);

    useEffect(() => {
        function onMessage(e: MessageEvent) {
            if (e.data && e.data.type === "host-origin") {
                const raw = e.data.origin || e.origin;
                const matched = resolveBrandFromUrl(raw);
                if (matched) setActiveBrand(matched);
            } else if (e.origin) {
                const matched = resolveBrandFromUrl(e.origin);
                if (matched) setActiveBrand(matched);
            }
        }

        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, []);

    if (!activeBrand) {
        return null; 
    }

    return <BrandedApp brand={activeBrand} />;
}

export default App;
